import { Component, OnInit } from '@angular/core';
import { toAuth0DomainAuthorize } from 'src/app/shared/utils';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css'],
})
export class RedirectComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    location.href = toAuth0DomainAuthorize();
  }
}
